import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import Home from '../home';
import FixedHome from '../../shared/components/fixed-home';
import Auth from '../auth';
import TempNavigation from '../temp/temp-navigation';
import ResetPasswordCallback from '../auth/components/reset-password-callback';
import TempAuthIndicator from '../temp/temp-auth-indicator';
import ProtectedRoute from '../../shared/components/protected-route';
import ConnectEmailAccountCallback from '../settings/components/connect-email-account-callback';
import ConfigRoute from '../../shared/components/config-route';
import Error404 from '../../shared/components/error-404';
import VerifyEmailCallback from '../auth/components/verify-email-callback';
import OAuthAuthenticateCallback from '../auth/components/oauth-authenticate-callback';
import ErrorBoundaryWrapper from '../../shared/components/error-boundary-wrapper';
import connectWhitelabelEmailAccountCallback from '../settings/components/connect-whitelabel-email-account-callback';
import OAuthWhitelabelCallback from '../auth/components/oauth-whitelabel-callback/oauth-whitelabel-callback';
import InboxRadarShareableReport from '../inbox-radar/components/inbox-radar-shareable-report';
import Demo from '../auth/components/demo';
import Checkout from '../checkout/checkout';
import EmailInfraPay from '../email-infra-pay/email-infra-pay';
import DesignSystemPage from '../design-system-page';
// import DialerManager from '../../shared/components/dialer/dialer-manager';

const App: React.FC = () => (
  <>
    <FixedHome />
    <ErrorBoundaryWrapper>
      <Switch>
        <ConfigRoute
          title="Login"
          type={ConfigRoute.RouteType.Auth}
          exact
          path="/login"
          component={Auth}
        />
        <ConfigRoute
          title="Multi-Factor Authentication"
          type={ConfigRoute.RouteType.Auth}
          exact
          path="/mfa-verify"
          component={Auth}
        />
        <ConfigRoute
          title="Agency Login"
          type={ConfigRoute.RouteType.Auth}
          exact
          path="/agency/login"
          component={Auth}
        />
        <ConfigRoute
          title="SSO Login"
          type={ConfigRoute.RouteType.Auth}
          exact
          path="/sso-login"
          component={Auth}
        />
        <ConfigRoute
          title="SSO Login"
          type={ConfigRoute.RouteType.Default}
          exact
          path="/sso-callback"
          component={Auth}
        />
        <ConfigRoute
          title="MCP Auth Success"
          type={ConfigRoute.RouteType.Default}
          exact
          path="/mcp-auth-success"
          component={Auth}
        />
        <ConfigRoute
          title="Sign up"
          type={ConfigRoute.RouteType.Auth}
          exact
          path="/signup"
          component={Auth}
        />
        <ConfigRoute
          title="Sign up"
          type={ConfigRoute.RouteType.Auth}
          exact
          path="/LTD-Signup"
          component={Auth}
        />
        <ConfigRoute
          title="Reset Password"
          type={ConfigRoute.RouteType.Auth}
          exact
          path="/reset-password/:code"
          component={ResetPasswordCallback}
        />
        <ConfigRoute
          title="Accept Invitation"
          type={ConfigRoute.RouteType.Auth}
          exact
          path="/accept-invite/:token"
          component={Auth}
        />
        <ConfigRoute
          title="Reset Password"
          type={ConfigRoute.RouteType.Auth}
          exact
          path="/reset-password"
          component={Auth}
        />
        <ConfigRoute
          title="Verify Email"
          exact
          path="/verify-email"
          component={VerifyEmailCallback}
        />
        <ConfigRoute
          title="Saleshandy Demo"
          exact
          path="/demo"
          component={Demo}
        />
        <ConfigRoute exact path="/checkout" component={Checkout} />
        <ProtectedRoute exact path="/email-infra/pay" component={EmailInfraPay} />
        <ConfigRoute
          exact
          path="/auth/oauth-authenticate-callback/:method"
          component={OAuthAuthenticateCallback}
        />
        <ConfigRoute
          exact
          path="/oauth/whitelabel/callback"
          component={OAuthWhitelabelCallback}
          title="OAuth Callback"
        />
        <ProtectedRoute exact path="/LTD-Checkout" component={Auth} />
        <ProtectedRoute exact path="/verify-email" component={Home} />
        <ProtectedRoute exact path="/email-insights" component={Home} />
        <ProtectedRoute exact path="/tasks" component={Home} />
        <ProtectedRoute exact path="/tasks/:prospectId" component={Home} />
        <ProtectedRoute exact path="/tasks/:prospectId/:tab" component={Home} />
        <ProtectedRoute exact path="/prospects" component={Home} />
        <ProtectedRoute exact path="/crm" component={Home} />
        <ProtectedRoute exact path="/email-accounts" component={Home} />
        <ProtectedRoute exact path="/email-accounts/create" component={Home} />
        <ProtectedRoute
          exact
          path="/email-accounts/create-email-accounts"
          component={Home}
        />
        <ProtectedRoute
          exact
          path="/email-accounts/add-email-accounts"
          component={Home}
        />
        <ProtectedRoute
          exact
          path="/email-accounts/:hashId/:tab"
          component={Home}
        />
        <ProtectedRoute exact path="/domains" component={Home} />
        <ProtectedRoute exact path="/inframail-ips" component={Home} />
        <ProtectedRoute exact path="/prospects/table" component={Home} />
        <ProtectedRoute exact path="/dialer" component={Home} />
        <ProtectedRoute exact path="/dialer/call-logs" component={Home} />
        <ProtectedRoute
          exact
          path="/dialer/call-logs/voicemail-templates"
          component={Home}
        />
        <ProtectedRoute
          exact
          path="/dialer/call-logs/reports"
          component={Home}
        />
        <ProtectedRoute
          exact
          path="/dialer/call-logs/:callLogId/:tab"
          component={Home}
        />
        <ProtectedRoute exact path="/dialer/phone-numbers" component={Home} />
        <ProtectedRoute
          exact
          path="/dialer/phone-numbers/purchase"
          component={Home}
        />
        <ProtectedRoute
          exact
          path="/dialer/phone-numbers/:id/settings"
          component={Home}
        />
        {/* <ProtectedRoute exact path="/dialer-keypad" component={DialerManager} /> */}
        <ProtectedRoute exact path="/crm/table" component={Home} />
        <ProtectedRoute exact path="/crm/kanban" component={Home} />
        <ProtectedRoute exact path="/crm/kanban/:prospectId" component={Home} />
        <ProtectedRoute exact path="/crm/list" component={Home} />
        <ProtectedRoute exact path="/crm/list/:prospectId" component={Home} />
        <ProtectedRoute
          exact
          path="/crm/list/:prospectId/:tab"
          component={Home}
        />
        <ProtectedRoute
          exact
          path="/crm/kanban/:prospectId/:tab"
          component={Home}
        />
        <ProtectedRoute exact path="/leads" component={Home} />
        <ProtectedRoute exact path="/leads/:prospectId" component={Home} />
        <ProtectedRoute exact path="/leads/:prospectId/:tab" component={Home} />
        <ProtectedRoute exact path="/v2/leads" component={Home} />
        <ProtectedRoute exact path="/v2/leads/:tab" component={Home} />
        <ProtectedRoute
          exact
          path="/v2/leads/:tab/:subtab/:prospectId"
          component={Home}
        />
        <ProtectedRoute
          exact
          path="/v2/leads/:tab/:subtab/:prospectId/:tab"
          component={Home}
        />
        <ProtectedRoute exact path="/v2/leads/:tab/:subtab" component={Home} />
        <ProtectedRoute exact path="/inbox-radar" component={Home} />
        <ProtectedRoute
          exact
          path="/inbox-radar/create-update-test"
          component={Home}
        />
        <ProtectedRoute
          exact
          path="/inbox-radar/create-update-test/:templateId"
          component={Home}
        />
        <ProtectedRoute
          exact
          path="/inbox-radar/create-update-test-external/:templateId"
          component={Home}
        />
        <ProtectedRoute exact path="/inbox-radar/report" component={Home} />
        <ProtectedRoute
          exact
          path="/inbox-radar/report/:testId"
          component={Home}
        />
        <ConfigRoute
          exact
          path="/inbox-radar/shareable/:templateId/:runId"
          component={InboxRadarShareableReport}
          title="Inbox Radar"
        />
        <ProtectedRoute exact path="/reports" component={Home} />
        <ProtectedRoute exact path="/reports/:tab" component={Home} />
        <ProtectedRoute exact path="/growth-hub" component={Home} />
        <ProtectedRoute exact path="/agency-portal" component={Home} />
        <ProtectedRoute exact path="/clients" component={Home} />
        <ProtectedRoute path="/warmup" component={Home} />
        <ProtectedRoute exact path="/templates" component={Home} />
        <ProtectedRoute exact path="/conversations" component={Home} />
        <ProtectedRoute exact path="/conversations/:hashId" component={Home} />
        <ProtectedRoute
          exact
          path="/conversations/:hashId/:prospectId"
          component={Home}
        />
        <ProtectedRoute
          exact
          path="/conversations/:hashId/:prospectId/:tab"
          component={Home}
        />
        <ProtectedRoute exact path="/email-verifier" component={Home} />
        <ProtectedRoute
          exact
          path="/settings/email-accounts/verify/:method"
          component={ConnectEmailAccountCallback}
        />
        <ConfigRoute
          exact
          path="/settings/whitelabel/email-accounts/verify/:method"
          component={connectWhitelabelEmailAccountCallback}
        />
        <ProtectedRoute path="/billing" component={Home} />
        <ProtectedRoute path="/settings" component={Home} />
        <ProtectedRoute path="/block" component={Home} />
        <ProtectedRoute exact path="/sequence" component={Home} />
        <ProtectedRoute
          exact
          path="/sequence/:sequenceId/prospects/:prospectId/:tab"
          component={Home}
        />
        <ProtectedRoute
          exact
          path="/sequence/:sequenceId/emails/:prospectId/:tab"
          component={Home}
        />
        <ProtectedRoute
          exact
          path="/sequence/:sequenceId/:activeTab"
          component={Home}
        />
        <ProtectedRoute
          exact
          path="/sequence/:sequenceId/subsequence/:subsequenceId/:subsequenceActiveTab"
          component={Home}
        />
        <Redirect from="/sequence" to="/sequence" />
        <Route exact path="/navigation" component={TempNavigation} />
        <Route exact path="/auth-indicator" component={TempAuthIndicator} />
        <Redirect exact from="/" to="/sequence" />

        {process.env.REACT_APP_ENV !== 'production' && (
          <ConfigRoute
            exact
            path="/design-system"
            title="Design System"
            type={ConfigRoute.RouteType.Default}
            component={DesignSystemPage}
          />
        )}
        <ConfigRoute
          exact
          path="/not-found"
          title="Not Found"
          type={ConfigRoute.RouteType.Default}
          component={Error404}
        />
        <ConfigRoute title="Not Found" component={Error404} />
      </Switch>
    </ErrorBoundaryWrapper>
  </>
);

export default App;
